import DomManipulate from './DomManipulate';
import Guide from './Guide';
import ProductsFilters from "./ProductsFilters";

export default class OverviewProducts {
    constructor(selector) {
        this.Guide = new Guide();
        this.ProductsFilters = new ProductsFilters();
    }
  checkForLteItems(stringToCheck) {
    let hasBeenFound = false;
    $('.js-main-col-hook').each(function () {
      const data = $(this).attr('data-product-object');
      try {
        const dataObj = JSON.parse(data);
        stringToCheck.forEach((string) => {
          if(string === dataObj.partnumber) {
            hasBeenFound = true;
          }
        })
      } catch (e) {
        console.log(e.message);
      }
    });
    return hasBeenFound;
  }

    init() {
        const dom = new DomManipulate();

      let hasLTEItems = this.checkForLteItems([
        'EVO-ONE-LTE',
        'EVO-ALL-LTE'
      ]);
      if (!hasLTEItems) {
        document.getElementById('mobile_app_remote_included').parentNode.style.display = "none";

        const elem = document.querySelector('.collapse_item[data-target="#filter-section-body-0"] h4');
        const innerHTMLOfElem = elem.innerHTML;
        const oldNumber = innerHTMLOfElem.match(/\d+/)[0];
        let newNumber = parseInt(oldNumber) - 1;
        elem.innerHTML = innerHTMLOfElem.replace(oldNumber, newNumber);
      }

        dom.onReady(() => {
            this.Guide.init();
            this.ProductsFilters.init();
            this.addEvents();
        })
    }

    addEvents() {
        $('.guide-overlay').on('click', (e) => this.Guide.toggleOverlay(e.currentTarget.attributes["data-partnumber"].value));
    }
};
